import { FC } from 'react'
import Link from 'next/link'

type Props = {
  currentPage: number
  urls: string[]
}

const Component: FC<Props> = ({ urls, currentPage }) => {
  const activePage = (idx: number) => {
    return idx === currentPage ? 'bg-secondary-800 rounded-full text-white font-medium' : 'text-secondary-800'
  }
  return (
    <section className="flex gap-2">
      {urls.map((url, idx) => {
        return (
          <div
            key={idx}
            className={`${activePage(idx + 1)} w-6 h-6 align-middle text-center flex justify-center items-center`}
          >
            {idx + 1 === currentPage ? (
              <p>{currentPage}</p>
            ) : (
              <Link key={url} href={url} prefetch={false}>
                <a>{idx + 1}</a>
              </Link>
            )}
          </div>
        )
      })}
    </section>
  )
}

export default Component
